import { configureStore } from '@reduxjs/toolkit';
import activeWorkspaceSlice from './features/active-workspace/slice';
import workspacesSlice from './features/workspaces/slice';
import topicsSlice from './features/topics/slice';
import datasourcesSlice from './features/datasources/slice';
import workspaceSlice from './features/workspace/slice';
import alertSlice from './features/alerts/slice';
import wssSlice from './features/wss/slice';
import usersSlice from './features/users/slice';
import modelsSlice from './features/models/slice';
import adminMonitoringSlice from './features/admin-monitoring/slice';
import adminAgentTasksSlice from './features/admin-agent-tasks/slice';
import adminArtifactsSlice from './features/admin-artifacts/slice';
import tamedDataSlice from './features/tameddata/slice';
import artifactsSlice from './features/artifacts/slice';
import foldersSlice from './features/folders/slice';
import teamMessagingSlice from './features/team-messaging/slice';
import deleteDialogSlice from './features/deleteDialog/slice';
import importSidebarSlice from './features/importSidebar/slice';
import adminWorkspacesSlice from './features/admin-workspaces/slice';
import callsSlice from './features/calls/slice';

export const store = configureStore({
    reducer: {
        activeWorkspace: activeWorkspaceSlice,
        workspaces: workspacesSlice,
        topics: topicsSlice,
        datasources: datasourcesSlice,
        workspace: workspaceSlice,
        alert: alertSlice,
        wss: wssSlice,
        users: usersSlice,
        models: modelsSlice,
        adminMonitoring: adminMonitoringSlice,
        adminAgentTasks: adminAgentTasksSlice,
        adminArtifacts: adminArtifactsSlice,
        tamedData: tamedDataSlice,
        artifacts: artifactsSlice,
        folders: foldersSlice,
        teamMessaging: teamMessagingSlice,
        deleteDialog: deleteDialogSlice,
        importSidebar: importSidebarSlice,
        adminWorkspaces: adminWorkspacesSlice,
        calls: callsSlice
    }
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;